import { ITranslation } from "./types";

export const pt: ITranslation = {
  messageFallbacks: {
    homeOrderNotReadyMsg:
      'Acabou de sair da loja? O seu recibo está a ser processado, por favor volte a verificar dentro de momentos.<br/>Em caso de qualquer problema, por favor contacte o apoio ao cliente do espaço.',
    errorReachOutSupportMsg:
      'Em caso de qualquer problema, por favor contacte o apoio ao cliente do espaço.',
  },
  api: {
    E_FORCED_LOGOUT: "A sua sessão foi terminada porque a ligação expirou.",
  },
  orderStatus: {
    draft: "Rascunho",
    contested: "Contestado",
    paid: "Pago",
    unpaid: "Não pago",
    pending: "Pendente",
    reviewed: "Revisto",
    paymentProcessing: "Pagamento em processamento",
    refunded: "Reembolsado",
    unknown: "Desconhecido",
  },
  receiptsList: {
    headings: {
      date: "Data",
      time: "Hora",
      status: "Estado",
      total: "Total",
    },
    action: {
      view: "Ver",
    },
    statusTooltip: {
      draft: "Rascunho - Encomenda a ser processada pelo sistema",
      paid: "Pago - Encomenda processada e paga",
      paymentProcessing:
        "Pagamento em processamento - Encomenda processada e pagamento em curso",
      unpaid: "Não pago - Encomenda processada, mas o pagamento falhou",
      pending:
        "Pendente - Encomenda contestada pelo cliente e a aguardar revisão por parte do retalhista",
      reviewed:
        "Revisto - Encomenda contestada pelo cliente e o retalhista submeteu a revisão",
    },
    loadMore: "Carregar mais",
    loadingMore: "A carregar...",
    showing: "A mostrar",
  },
  receiptDetailScreen: {
    headerTitle: "Detalhe do recibo",
    subtotal: "Subtotal",
    taxBreakdown: {
      headers: {
        rate: "IVA %",
        netto: "Líquido",
        brutto: "Bruto",
        tax: "IVA",
        total: "Total:",
      },
    },
    tax: "IVA",
    taxCRV: "CRV",
    total: "Total",
    processTime: "Tempo de processamento",
    date: "Data",
    paymentStatus: "Estado do pagamento",
    orderId: "ID da encomenda",
    listOfProducts: "Produtos",
  },
  receiptDetailComplain: {
    reportProblem: "Comunicar um problema com este recibo",
    submitReview: "Enviar para revisão",
    confirmTitle: "Recibo enviado",
    confirmButton: "Concluído",
    addMissingItem: "Adicionar artigo em falta",
    addMissingItemMessage: "Adicionar uma mensagem (opcional)",
    form: {
      email: {
        label: 'Como podemos contactá-lo?',
        placeholder: 'O seu e-mail, ex. eu@exemplo.com',
        errors: {
          required: 'O endereço de e-mail é obrigatório.',
          isEmail: 'O endereço de e-mail não é válido.',
          inUse: 'O endereço de e-mail já está a ser utilizado.'
        }
      }
    }
  },
  receiptsScreen: {
    label: {
      contested: "EM REVISÃO",
      draft: "RASCUNHO",
      empty: "VAZIO",
      paid: "PAGO",
      pending: "RASCUNHO",
      refunded: "REEMBOLSADO",
      reviewed: "REVISTO",
      unknown: "DESCONHECIDO",
      unpaid: "NÃO PAGO",
      paymentProcessing: "PAGAMENTO EM PROCESSAMENTO",
    },
    message: {
      contested: "Recibo contestado",
      draft: "Recibo em rascunho",
      empty: "Recibo vazio",
      paid: "Recibo pago",
      pending: "Recibo pendente",
      refunded: "Recibo reembolsado",
      reviewed: "Recibo revisto",
      unpaid: "Recibo não pago",
      paymentProcessing: "Pagamento em processamento",
    },
    minutes: "minutos",
    hours: "horas",
    days: "dias",
  },
  slideModal: {
    close: "Fechar",
    searchPlaceholder: "Procurar artigo",
  },
  receiptsHome: {
    receiptPortal: "Portal de recibos",
    selectPaymentType:
      "Selecione o método de pagamento que utilizou para entrar na loja",
    selectPaymentTypeSubtitle: "Se aproximou o seu telemóvel ou smartwatch, escolha Apple Pay ou Google Pay",
    cardBin: "Primeiros %{cardBinDigitsCount} dígitos do número do cartão (BIN/IIN)",
    last4: "Últimos quatro dígitos do seu método de pagamento",
    last4Apple: "Últimos quatro dígitos do seu número Apple Pay",
    last4Google: "Últimos quatro dígitos do seu número Google Pay",
    instructionApple:
      "Encontre os últimos quatro dígitos do número do seu cartão Apple Pay na Apple Wallet e introduza-os abaixo",
    openWallet: "Abrir Wallet",
    instructionGoogle:
      "Encontre os últimos quatro dígitos do número do seu cartão Google Pay na sua Wallet e introduza-os abaixo",
    instructionExternalId:
      "Encontre o número de referência do pagamento na sua aplicação de pagamentos ou no extrato bancário.",
    externalIdLabel: "Número de referência do pagamento",
    externalIdPlaceholder: "",
    expDate: "Data de validade",
    visitDate: "Data da sua visita",
    submit: "Obter recibo(s)",
    registerEmail: "Introduza o seu e-mail para subscrever recibos futuros",
    registerEmailSuccess: "Endereço de e-mail atualizado com sucesso.",
    registerEmailFail:
      "O endereço de e-mail não foi atualizado porque não existem recibos associados aos dados do cartão de crédito e/ou à data de visita indicados.",
    unrecognizedError: "Ocorreu um erro não reconhecido",
    inconclusiveCardInfo: "Não conseguimos encontrar o seu recibo",
    optionalFieldPlaceholder: 'Opcional',
    invalidCaptcha: "Captcha inválido, por favor tente novamente",
    oasisApiError:
      "Não foi possível ligar ao servidor de recibos. Por favor tente novamente mais tarde.",
    orderNotFound: "Encomenda não encontrada",
    vatNumberLabel: "Número de contribuinte",
    vatNumberOptional: "(opcional)",
    vatNumberHelp:
      "Se quiser adicionar um número de contribuinte a faturas futuras, introduza-o aqui.",
    vatNumberError: "Introduza um número de contribuinte (NIF) português válido.",
  },
  receiptError: {
    notFound: {
      title: "Recibo não encontrado",
      message: "Não foi possível encontrar um recibo para esta encomenda. Pode ter expirado, ter sido removido ou o link pode estar incorreto.",
      retry: "Tentar novamente",
      contactSupport: "Contactar o apoio ao cliente",
      goBack: "Voltar",
    },
    serverError: {
      title: "Algo correu mal",
      message: "A falha é nossa. Por favor tente novamente dentro de momentos. Se o problema persistir, contacte a nossa equipa de apoio.",
      retry: "Tentar novamente",
      contactSupport: "Contactar o apoio ao cliente",
    },
  },
  notFound: {
    title: "Página não encontrada",
    message: "Algo correu mal ou o link pode estar incorreto.",
    goHome: "Ir para a página inicial",
    goBack: "Voltar",
  },
};
